export default __webpack_public_path__ + "static/media/hellsgarden.19d989e0.png";